function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function toLine(name) {
  return name.replace(/([A-Z])/g, '-$1').toLowerCase();
}

export var colors = {
  purpleMain: '#5858FF',
  purpleDark: '#4A4AD6',
  purpleMedium: '#7373FF',
  purpleIllustration: '#CCCCFF',
  purpleLight: '#F6F6FF',
  orangeMain: '#FF6652',
  orangeDark: '#F34F3A',
  orangeMedium: '#FFCCCC',
  black: '#212121',
  charcoal: '#424242',
  granite: '#666666',
  stone: '#999999',
  fog: '#BDBDBD',
  grey: '#EEEEEE',
  ice: '#F9F9F9',
  white: '#FFFFFF',
  yellow: '#CF8909',
  yellowLight: '#FFF9ED',
  red: '#DE3618',
  redMedium: '#F52209',
  redLight: '#FEE4E1',
  blue: '#1E90FF',
  blueLight: '#E4F2FF',
  green: '#108043',
  greenMedium: '#2ED573',
  greenLight: '#EEFFEA'
};
var themeColors = {};

for (var key in colors) {
  themeColors[toLine(key)] = colors[key];
}

export default _objectSpread(_objectSpread({}, themeColors), {}, {
  'primary-color': colors.purpleMain,
  'outline-width': '0px',
  'font-family': 'Roboto',
  'line-height-base': '1.2857',
  'height-base': '48px',
  'height-sm': '40px',
  'font-size-base': '16px',
  'statistic-content-font-size': 'inherit',
  'statistic-unit-font-size': 'inherit',
  //base
  'border-radius-base': '3px',
  //form
  'label-color': '#6B778C',
  'label-required-color': '#6B778C',
  'form-item-label-font-size': '16px',
  'form-item-label-height': '18px',
  //buttons
  'btn-border-radius-base': '3px',
  'btn-default-border': colors.purpleMain,
  'btn-default-color': colors.purpleMain,
  'btn-default-bg': 'transparent',
  //select
  'select-dropdown-line-height': '32px',
  'select-item-active-bg': colors.ice,
  'select-item-selected-bg': colors.purpleLight,
  'select-item-selected-font-weight': 'normal',
  'select-item-selected-color': colors.black,
  'select-multiple-item-height': '32px',
  //checkbox
  'checkbox-size': '20px',
  //collapse
  'collapse-header-bg': '#ffffff',
  'collapse-header-padding': '24px 16px',
  //radio
  'radio-size': '18px',
  'radio-dot-size': '0px',
  //pagination
  'pagination-item-size-sm': '40px',
  //color
  'error-color': '#f52209',
  'disabled-border-color': '#eeeeee',
  'disabled-background-color': '#f9f9f9',
  'divider-color': '#eeeeee',
  'active-color': ' #4a4ad6',
  'hover-color': '#7373ff'
});